<template>
  <div class="main-content container-fluid fixed">
    <div class="purchase-program row">
      <div class="col-1"></div>
      <main class="col-8">
        <div class="inside-info">
          <div class="row">
            <div class="col">
              <MemberInfoBar ref="member-info-bar" @setMember="setMember" />
            </div>
          </div>

          <div class="row purchase-list">
            <div class="col-12">
              <div class="purchase-list__title">
                購買方案
              </div>
            </div>

            <OneProgram
              v-for="(program, index) in programList"
              :key="index"
              :id="'program_' + index"
              :program="program"
              @chooseProgram="chooseProgram"
            />
          </div>
        </div>
      </main>
      <SidebarMenu :level="level" />
      <ProgramModal :program="choseProgram" :push="true" :level="level" />
    </div>
  </div>
</template>

<script>
import SidebarMenu from '@/components/Layouts/SidebarMenu';
import OneProgram from '@/components/PurchaseProgram/OneProgram';
import ProgramModal from '@/components/Modal/ProgramModal';
import { fetchPrograms } from '@/api/program';
import { mapGetters } from 'vuex';
import MemberInfoBar from '@/components/MemberInfoBar';

export default {
  components: {
    SidebarMenu,
    OneProgram,
    ProgramModal,
    MemberInfoBar
  },
  computed: {
    ...mapGetters('order', ['programs']),
    ...mapGetters('member', ['memberId', 'branchId'])
  },
  data() {
    return {
      mobile: '',
      uniformNum: '',
      phone: '',
      programList: [],
      choseProgram: {},
      level: {}
    };
  },
  created() {
    if (this.memberId == 1) {
      this.$router.push({ name: '歷史購買紀錄' }).catch(() => {});
    }
    this.fetchPrograms();
  },
  methods: {
    fetchPrograms() {
      fetchPrograms({ branch_id: this.branchId }, programs => {
        this.programList = programs;
      });
    },
    chooseProgram(choseProgram) {
      // let oldProgram = this.programs.find(
      //   program => program.program_id == choseProgram.program_id
      // );

      // this.choseProgram = Object.assign(choseProgram, oldProgram);
      this.choseProgram = choseProgram;

      this.openModal();
    },
    openModal() {
      this.$bvModal.show(`program-modal-purchase-product`);
    },
    setMember(member) {
      this.level = member.level;
    }
  }
};
</script>
